import Axios from "axios";
import { action, decorate, observable } from "mobx";

export default class ManageDownloadsStore {
    list_data = null;
    getList = (conditional = {}) => {
        return Axios.get(`help/help-items/downloadlist`, { params: conditional }).then(({ data }) => {
            this.list_data = data.list
        });
    }
    

}

decorate(ManageDownloadsStore, {
    list_data: observable,
    getList: action
});